import React, { Component } from 'react'

export class LogCountTooltip extends Component {
    constructor(props) {
        super(props);
      }

    render() {
        return (
            <>   
                <div className="contactVia">
                      <label>Contacted via</label>
                      {this.props.textCount >0 && <div className="rowSpaceBetween marginBottom alignMiddle">
                        <span>Text Message</span>
                        <span className="notification">{this.props.textCount}</span>
                      </div>}
                      {this.props.emailCount >0 && <div className="rowSpaceBetween alignMiddle">
                        <span>Email</span>
                        <span className="notification">{this.props.emailCount}</span>
                      </div>}
                    </div>
            </>
        )
    }
}

export default LogCountTooltip
